// material-ui
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

// types
import { ThemeMode } from '@app/types/config.ts';
import { useDashboardSelector } from '@hooks/useDashboard';
import SupportOutlinedIcon from '@mui/icons-material/SupportOutlined';

function HelpCenterSection() {
  const theme = useTheme();
  const toggleHelpCenterOpened = useDashboardSelector(
    (state) => state.toggleHelpCenterOpened
  );

  return (
    <>
      <Box sx={{ ml: 2 }}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            bgcolor:
              theme.palette.mode === ThemeMode.DARK
                ? 'dark.main'
                : 'secondary.light',
            color:
              theme.palette.mode === ThemeMode.DARK
                ? 'warning.dark'
                : 'secondary.dark',
            '&[aria-controls="menu-list-grow"],&:hover': {
              bgcolor:
                theme.palette.mode === ThemeMode.DARK
                  ? 'warning.dark'
                  : 'secondary.dark',
              color:
                theme.palette.mode === ThemeMode.DARK
                  ? 'grey.800'
                  : 'secondary.light',
            },
          }}
          onClick={toggleHelpCenterOpened}
          color="inherit"
        >
          <SupportOutlinedIcon
            sx={{
              strokeWidth: 1.5,
              fontSize: '20px',
            }}
          />
        </Avatar>
      </Box>
    </>
  );
}

export default HelpCenterSection;
